import {
  DesignProp,
  LayoutProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";

export const columns = {
  prop: "style-attribute",
  name: "Columns",
  nameI18n: "builder_ui.prop_type.styles.columns",
  category: [DesignProp, LayoutProp],
  type: "number",
  numberProps: {
    min: 1,
    max: 30,
    step: 1,
  },
} as const;
